var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 19,
    viewBox: "0 0 35 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 13.4488C32.9867 13.5419 28.741 11.4029 28.3205 11.2304C23.8401 9.39285 19.5762 9.26021 14.8089 9.26021C12.0161 9.26021 9.3761 9.90214 7.34039 7.86401C6.97402 7.49721 6.45816 7.19817 7.40237 7.0263C9.14374 6.70931 10.848 5.91 12.3917 5.0406C13.6698 4.32084 14.8179 3.48089 15.9866 2.62053C16.2109 2.45538 17.62 2 16.9782 2C12.758 2 8.53026 5.68501 4.95416 7.58477C4.40849 7.87466 1.05689 8.84982 2.25805 9.32226C3.58253 9.84321 4.72551 10.921 5.91485 11.6803C7.86443 12.925 9.46916 14.8573 11.4001 15.9619C11.8981 16.2469 12.8598 17.4759 13.1975 16.7997",
    stroke: "#858585",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBack);
export default __webpack_public_path__ + "static/media/video-back.9e90b7026b00d70fcf19c2ede7e824f8.svg";
export { ForwardRef as ReactComponent };